import ImageZoomView from 'components/ImageZoomView';
import { cn } from 'utils/classNames';

interface Image {
	alt?: string | undefined;
	height?: number;
	src: string;
	width?: number;
}

interface Props {
	image: Image;
	isZoomed: boolean;
	onZoomStart: () => void;
	onZoomStop: () => void;
}

const LARGE_SIZE = 2048;

export default function MediaDialogZoomView({
	image,
	isZoomed,
	onZoomStart,
	onZoomStop,
}: Props) {
	return (
		<ImageZoomView
			src={image.src}
			alt={image.alt}
			// Don't want width or height to be zero.
			// oxlint-disable-next-line typescript/prefer-nullish-coalescing
			width={image.width || LARGE_SIZE}
			// oxlint-disable-next-line typescript/prefer-nullish-coalescing
			height={image.height || LARGE_SIZE}
			className={cn('relative z-1 w-full', !isZoomed && 'h-full')}
			innerContainerClassName={cn(!isZoomed && 'h-full')}
			imageContainerClassName={cn(
				!isZoomed && 'h-full',
				// Unfortunate ugliness to keep image height contained.
				// Full height minus zoom controls:
				// - Up/down buttons * 2
				// - Up/down buttons gap
				// - Controls area padding * 2
				// - Controls area border
				// - On md, add this dialog's backdrop padding
				// TODO: should not be needed.
				isZoomed && [
					'h-[calc(100dvh-(3rem*2)-0.5rem-(1rem*2)-1px)]',
					'md:h-[calc(100dvh-(3rem*2)-0.5rem-(1rem*2)-1px-(var(--r-space-md)*2))]',
				],
			)}
			onZoomStart={onZoomStart}
			onZoomStop={onZoomStop}
		/>
	);
}
MediaDialogZoomView.displayName = 'MediaDialogZoomView';
